import { useContext } from 'react';
import { AppConfigType } from '../../config/types';
import { AppConfigContext } from '../../layout/AppConfigContext';

const useConfig = (): AppConfigType => {
    return useContext(AppConfigContext);
};

export default useConfig;
